"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;

var _noty = require("noty");

function show(text) {
  (0, _noty.showNotificationText)(text);
}